<template>
	<el-container class="full">
		<!-- 侧边 -->
		<el-aside width="200px">
			<side-bar>
				<div slot="trademark" class="title-box">
					<img src="../assets/logo.png">
				</div>
				<div slot="router">
					<component v-for="item in menuList" :key="item.name" :data="item"
						:is="(item.children && item.children.length)?'sub-menu':'menu-item'" />
				</div>
			</side-bar>
		</el-aside>
		<el-container class="full-height bg-gray">
			<!-- 头部 -->
			<el-header class="no-padding index-header" style="height:73px;z-index: 1999;">
				<top-bar />
			</el-header>
			<!-- 主体 -->
			<div class="main">
				<router-view class="content" />
			</div>
		</el-container>
	</el-container>
</template>
<script>
	/* eslint-disable space-infix-ops */

	import TopBar from "../components/TopBar";
	import SideBar from "../components/side-bar";
	import MenuItem from "../components/side-bar/menu-item";
	import SubMenu from "../components/side-bar/sub-menu";
	import {
		pms2MenuList,
		decrypt
	} from "../filters/filter";
	import {
		mapState
	} from "vuex";

	export default {
		name: "Index",
		data() {
			return {
				menuList: [],
				oldMenus: [{
					iconClass: 'el-icon-menu',
					name: '工作台',
					url: '/console',
				}, {
					iconClass: 'el-icon-user',
					name: '用户管理',
					url: '/user-list',
					children: [{
							name: '用户列表',
							url: '/user-list'
						},
						{
							name: '企业管理',
							url: '/company-list'
						}
					]
				}, {
					iconClass: 'el-icon-trophy',
					name: '会员管理',
					url: '/member-list',
					children: [{
							name: '付费会员列表',
							url: '/member-list'
						},
						{
							name: '会员配置',
							url: '/member-setting'
						},
					]
				}, {
					iconClass: 'el-icon-date',
					name: '课程管理',
					url: '/course-type-list',
					children: [{
						name: '课程列表',
						url: '/course-list'
					},{
						name: '课程推荐管理',
						url: '/course-rec-list'
					},{
						name: '课程下发管理',
						url: '/course-lssued-list'
					}, {
						name: '课程分类管理',
						url: '/course-type-list'
					}, ]
				}, {
					iconClass: 'el-icon-c-scale-to-original',
					name: '培训管理',
					url: '/training-list',
					children: [{
							name: '培训列表',
							url: '/training-list'
						},
						{
							name: '培训推荐管理',
							url: '/training-rec'
						},
						{
							name: '培训分类管理',
							url: '/training-type'
						},
					]
				}, {
					iconClass: 'el-icon-goods',
					name: '订单管理',
					url: '/order-list',
					children: [{
							name: '课程订单',
							url: '/course-order-list'
						},
						{
							name: '培训订单',
							url: '/training-order-list'
						},
						{
							name: '会员订单',
							url: '/member-order-list'
						},
					]
				}, {
					iconClass: 'el-icon-collection-tag',
					name: '营销管理',
					url: '/marketing-list',
					children: [{
							name: '积分管理',
							url: '/points-manage'
						},
						{
							name: '积分下发',
							url: '/points-issuance-list'
						},
						{
							name: '问题反馈',
							url: '/feedback-list'
						},
						{
							name: '消息推送',
							url: '/message-list'
						},
					]
				}, {
					iconClass: 'el-icon-data-line',
					name: '展示管理',
					url: '/views-list',
					children: [{
							name: 'Banner管理',
							url: '/banner-list'
						},
						{
							name: '关于我们',
							url: '/about-us'
						},
						{
							name: '核心技术',
							url: '/core-technology'
						},
						{
							name: '服务据点管理',
							url: '/service-list'
						},
						{
							name: '常见问题',
							url: '/question-list'
						},
					]
				}, {
					iconClass: 'el-icon-pie-chart',
					name: '数据统计',
					url: '/statics-manage',
					children: [{
							name: '财务指标',
							url: '/finanic-statics'
						},
						{
							name: '综合数据分析',
							url: '/compre-data-statics'
						},
					]
				},{
					iconClass: 'el-icon-folder-remove',
					name: '权限管理',
					url: '/auths-manage',
					children: [{
							name: '菜单管理',
							url: '/menu-list'
						},{
							name: '角色管理',
							url: '/role-list'
						},
						{
							name: '管理员列表',
							url: '/admin-list'
						},
						{
							name: '操作日志',
							url: '/log-list'
						},
					]
				}, ,{
					iconClass: 'el-icon-folder-remove',
					name: '协议管理',
					url: '/contents',
					children: [{
							name: '用户协议',
							url: '/yhxy'
						},{
							name: '隐私协议',
							url: '/ysxy'
						},
						{
							name: '补充协议',
							url: '/bcxy'
						},
					]
				}, ],
				newOrders: [],
				dialogVisible: false,
				timer: null
			};
		},
		components: {
			TopBar,
			SideBar,
			MenuItem,
			SubMenu
		},
		created() {
			const encryptedPermission = sessionStorage.getItem('permission')
			this.menuList = JSON.parse(encryptedPermission);
			this.addIconsWithMap(this.oldMenus,this.menuList)
			// this.menuList = this.menuList.concat(JSON.parse(encryptedPermission));
			// this.menuList = pms2MenuList(JSON.parse(decrypt(this.permissionList)));
		},
		mounted() {},
		methods: {
			addIconsWithMap(menuList1, menuList2) {
				// 创建name到菜单项的映射
				const menuMap = new Map();

				function buildMap(menuArray) {
					menuArray.forEach(menu => {
						menuMap.set(menu.name, menu);
						if (menu.children) {
							buildMap(menu.children);
						}
					});
				}

				buildMap(menuList1);

				function applyIcons(menuArray) {
					menuArray.forEach(menu => {
						const originalMenu = menuMap.get(menu.name);
						if (originalMenu && originalMenu.iconClass) {
							menu.iconClass = originalMenu.iconClass;
						}
						if (menu.children) {
							applyIcons(menu.children);
						}
					});
				}

				applyIcons(menuList2);
			},
			notification(item) {
				let that = this;
				Notification.requestPermission().then(function(result) {
					if (result == "granted") {
						var notification = new Notification("酒店管理后台管理员：", {
							body: `你有新的订单，请及时处理`,
							icon: "https://hotel-cdn.yxhotel.vip/FoNiwhNNUJMqf9pil87b6nw7cC2A"
						});
						// notification.onclick = function() {
						//   // window.open('https://web-hotel-manage-admin.gymooit.cn/#/order-list')
						//   let route = that.$router.resolve({
						//     name: "order-list"
						//   });
						//   window.open(route.href, "_blank");
						// };
					}
				});
			}
		},
		computed: {
			...mapState(["permissionList"])
		},
		watch: {}
	};
</script>

<style lang="less">
	.index-header {
		position: absolute;
		// background: rgba(7, 19, 62, 1);
		z-index: 2;
	}

	.el-header {
		padding-left: 0;
	}
</style>
<style lang="less" scoped>
	.title-box {
		background-color: #00284d;
		padding: 10px;
		width: 200px;
		height: 73px;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		img {
			width: 130px;
			height: auto;
		}
	}

	.full-height {
		height: 100vh;
		overflow: hidden;
		overflow-y: auto;
	}

	.main .content {
		padding: 20px;
		margin-top: 73px;
	}

	.news-item {
		display: flex;
		align-items: center;
		padding: 22px 30px;
		border-bottom: 1px solid #ccc;

		.icon {
			width: 52px;
			height: 52px;
		}

		.middle {
			text-align: left;
			width: 300px;
		}

		.sub-content {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
		}

		.btn {
			width: 88px;
			height: 40px;
			margin-left: auto;
			background: rgba(255, 192, 50, 1);
			border: none;
		}
	}

	/deep/.index-dialog {
		/deep/.el-dialog__header {
			padding: 0 !important;
		}

		/deep/.el-dialog__body {
			padding-left: 0;
			padding-right: 0;
		}

		.dialog-title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			height: 98px;
			box-sizing: border-box;
			padding: 12px 30px;
			background: rgba(255, 192, 50, 1);

			.slogan {
				font-size: 22px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: rgba(255, 255, 255, 1);
				line-height: 30px;
			}

			.title {
				font-size: 28px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: rgba(255, 255, 255, 1);
				line-height: 40px;
			}

			.allBtn {
				background: rgba(255, 155, 13, 1);
				width: 120px;
				height: 40px;
				color: rgba(255, 255, 255, 1);
				border: none;
			}
		}
	}
</style>